import ChackValveDetail from "../components/configuration/chackValveDetail/ChackValveDetail";

const ChackValveDetailPage = () =>{
    return(
            <ChackValveDetail/>
    )
}

export default ChackValveDetailPage;